import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldLabel } from '../../../../../../helpers/collaborativeIndexations'
import { GregorianContainer } from './DateCalendars/Gregorian'
import { RepublicanContainer } from './DateCalendars/Republican'

class DateCalendar extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        field: PropTypes.object,
        fieldName: PropTypes.string.isRequired,
        resetInvalidField: PropTypes.func.isRequired,
        updateGregorianDate: PropTypes.func.isRequired,
        updateRepublicanDate: PropTypes.func.isRequired,
        hasFocus: PropTypes.bool,
    }

    constructor(props)
    {
        super(props)
        this.state = { calendarType: null }

        this.changeCalendarType = this.changeCalendarType.bind(this)
        this.mainField = React.createRef()
    }

    componentDidMount()
    {
        if(this.props.field)
        {
            this.setState({calendarType: this.props.field.type})
        }

        if(this.props.hasFocus === true)
        {
            this.mainField.current.focus()
        }
    }

    changeCalendarType(event)
    {
        this.props.resetInvalidField(this.props.fieldName)

        const calendarType = event.currentTarget.value
        if(calendarType === 'gregorian')
        {
            this.props.updateGregorianDate(this.props.fieldName, {})
        }
        if(calendarType === 'republican')
        {
            this.props.updateRepublicanDate(this.props.fieldName, {})
        }

        this.setState({calendarType: event.currentTarget.value})
    }

    retrieveDateCalendarComponent()
    {
        if(this.state.calendarType === 'republican')
        {
            return RepublicanContainer
        }

        return GregorianContainer
    }

    render()
    {
        const { t, fieldName } = this.props

        const FieldComponent = this.retrieveDateCalendarComponent()

        return (
            <div className={'form-group'}>
                <label>{ translateFormFieldLabel(t, fieldName) }</label>

                <div className={'gregorianCalendar'}>
                    <input ref={this.mainField} checked={this.state.calendarType === 'gregorian' || this.state.calendarType === null} id={'gregorian'} name={'calendarType'} type={'radio'} value={'gregorian'} onChange={this.changeCalendarType} />
                    <label htmlFor={'gregorian'}>{t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.title')}</label>
                </div>

                <div className={'republicanCalendar'}>
                    <input checked={this.state.calendarType === 'republican'} id={'republican'} name={'calendarType'} type={'radio'} value={'republican'} onChange={this.changeCalendarType} />
                    <label htmlFor={ 'republican' }>{ t('visualizer:toolbar.left.collaborativeIndexationCreation.republicanForm.title') }</label>
                </div>

                <div className={'calendars'}>
                    { FieldComponent && <FieldComponent fieldName={fieldName}/> }
                </div>
            </div>
        )
    }
}

export default withTranslation()(DateCalendar)
